import request from './common/request'
import qs from 'qs'

import { MERCHANT_REPORT_PROJECT_TEMPLATE_URL } from './urls'

/**
 * 数据大屏列表
 */
async function list(query) {
  return request({
    url: `${MERCHANT_REPORT_PROJECT_TEMPLATE_URL}`,
    method: 'GET',
    params: query
  })
}

/**
 * 数据大屏详情
 */
async function detail(id) {
  return request({
    url: `${MERCHANT_REPORT_PROJECT_TEMPLATE_URL}/${id}`,
    method: 'POST',
    data: qs.stringify({ id })
  })
}

export default {
  list,
  detail
}



// WEBPACK FOOTER //
// ./src/api/merchant-simbart-activity-data-screen.js